import { CmsHtml } from '@packages/modules/src/CmsHtml/CmsHtml.client';
import { ComponentTypes } from '../../../interfaces/components';
import { CmsImage } from '../CmsImage/CmsImage';
import { BlockText } from '../Footer/BlockText/BlockText';
import { BlockList } from '../Footer/BlockList/BlockList';
import { BlockImage } from '../Footer/BlockImage/BlockImage';
import { BlockBadges } from '../Footer/BlockBadges/BlockBadges';
import { registerComponents } from './componentRegistry';
import { ImageGroup } from '../Footer/ImageGroup/ImageGroup.client';
import { ExternalScript } from '../ExternalScript/ExternalScript.client';

/**
 * Guard to prevent duplicate registrations
 */
let isRegistered = false;

/**
 * Registers footer components directly.
 * Components self-declare their server/client status via 'use client' directive.
 * Uses a guard to ensure registration only happens once.
 * don't forget to register the dynamic components if <ComponentRecognizer /> is in use. Example:
 * ```
 *    import { registerFlexibleComponents } from '@packages/cms-components/src/components/ComponentRecognizer/registerFlexibleComponents';
 *    registerFlexibleComponents();
 * ```
 */
export const registerFlexibleComponentsFooter = (): void => {
  // Early return if already registered
  if (isRegistered) {
    return;
  }

  isRegistered = true;

  registerComponents({
    [ComponentTypes.SvgFile]: CmsImage,
    [ComponentTypes.ImageSimple]: CmsImage,
    [ComponentTypes.ImageFooter]: CmsImage,
    [ComponentTypes.ExternalScript]: ExternalScript,
    [ComponentTypes.Html]: CmsHtml,
    [ComponentTypes.HtmlParagraph]: CmsHtml,
    [ComponentTypes.FooterGroupImage]: ImageGroup,
    [ComponentTypes.BlockText]: BlockText,
    [ComponentTypes.BlockList]: BlockList,
    [ComponentTypes.BlockImage]: BlockImage,
    [ComponentTypes.BlockBadges]: BlockBadges,
  });
};

/**
 * Resets the registration guard (for testing purposes only)
 * Call this in test setup to allow re-registration
 */
export const resetFlexibleComponentsFooterRegistration = (): void => {
  isRegistered = false;
};
